export default __webpack_public_path__ + "static/media/Category_385x420.ab316226.jpg";